module.exports = __webpack_public_path__ + "src/assets/games/31/253.jpg";